import React from 'react';
import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

const EmptyTable: React.FC = () => {
  return (
    <Table opacity="50%" w="100%">
      <Thead
        borderLeft="1px solid"
        borderRight="1px solid"
        borderColor="gray.700"
        bg="gray.800"
      >
        <Tr>
          <Th
            fontWeight={400}
            fontSize="12px"
            color="black"
            borderColor="gray.700"
          ></Th>
          <Th
            fontWeight={400}
            fontSize="12px"
            color="black"
            borderColor="gray.700"
          ></Th>
          <Th
            fontWeight={400}
            fontSize="12px"
            color="black"
            borderColor="gray.700"
          ></Th>
          <Th
            fontWeight={400}
            fontSize="12px"
            color="black"
            borderColor="gray.700"
          ></Th>
          <Th
            fontWeight={400}
            fontSize="12px"
            color="black"
            borderColor="gray.700"
          ></Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.700"
        >
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
        </Tr>
        <Tr
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.700"
        >
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
        </Tr>
        <Tr
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.700"
        >
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
        </Tr>
        <Tr
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.700"
        >
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
        </Tr>
        <Tr
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.700"
        >
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
          <Td borderColor="gray.700" fontSize="12px" color="gray.500"></Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default EmptyTable;
